import { insertIntoSupabase, selectFromSupabase, updateInSupabase, deleteFromSupabase } from "../helpers/supabase-api";

/**
 * Create a new block
 * @param {object} blockData - object containing the block data
 */
export function createBlock(blockData) {
  const block = JSON.parse(JSON.stringify(blockData));
  delete block.isNew;
  return insertIntoSupabase("blocks", block);
}

export function getBlock(id) {
  return selectFromSupabase("blocks", "*", { id }).then(results => results[0]);
}

export function getBlockByEmbedId(embedId) {
  return selectFromSupabase("blocks", "*", { embed_id: embedId }).then(results => results[0]);
}

export function getBlocks() {
  return selectFromSupabase("blocks", "*").then(data => ({ data }));
}

export function deleteAllBlocks(blocks) {
  const promises = blocks.map(block => deleteBlock(block.id));
  return Promise.all(promises);
}

/**
 * Delete a block
 * @param {string} id - block ID to delete
 */
export function deleteBlock(id) {
  return deleteFromSupabase("blocks", { id });
}

/**
 * Update a block
 * @param {string} id - block ID to update
 * @param {object} blockData - object of data to update
 */
export function updateBlock(id, blockData) {
  return updateInSupabase("blocks", blockData, { id });
}
